// extracted by mini-css-extract-plugin
export var container = "layout-module--container--kBhyd";
export var layout = "layout-module--layout--lZJMf";
export var skipLinks = "layout-module--skipLinks--e2VMd";